import { useState, useEffect } from 'react';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import './style.css';
import AlertMessage from '../../components/Alert';
import { CardContent } from '../../components/CardContent';
import { Main } from '../../components/Main';
import { Button, Card, Col, Container, Form, Modal, Modal as Modals, Row, Table } from 'react-bootstrap';
import api from '../../services/api';
import { Autocomplete, Box, TextField } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from '@mui/icons-material/Close';
import { DateTime } from 'luxon';
import { Options, Select } from '../../components/Select';
import { Label } from '../../components/Label';
import { FormGroup } from '../../components/FormGroup';
import PeriodicoSelect from '../../components/Reaproveitamentos/SelectPcmso';

const CadastrarPCMSO = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const navigate = useNavigate();
    const location = useLocation();
    const [inserirRiscoManual, setInserirRiscoManual] = useState(true)
    const [funcao, setFuncao] = useState([]);
    const [risco, setRisco] = useState([]);
    const [showGheModal, setShowGheModal] = useState(false);
    const [showAttachModal, setShowAttachModal] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [progressValue, setProgressValue] = useState(0);
    const [progressModalOpen, setProgressModalOpen] = useState(false);

    const [empresa, setEmpresa] = useState()
    const [idEmpresa, setIdEmpresa] = useState<number | null>(null)
    const [revisoes, setRevisoes] = useState([])
    const [ghes, setGhes] = useState([])
    const [revisaoSelecionada, setRevisaoSelecionada]: any = useState()
    const [gheSelecionado, setGheSelecionado]: any = useState()
    const [vigenciaSelecionada, setVigenciaSelecionada] = useState(DateTime.now().plus({years: 1}).toFormat('yyyy-MM'));
    
    // States para CRUD de função
    const [funcoes, setFuncoes] = useState([])
    const [funcaoSelecionada, setFuncaoSelecionada]: any = useState()
    const [cbo, setCbo]: any = useState()
    const [cboValue, setCboValue]: any = useState()
    const [descricaoFuncao, setDescricaoFuncao]: any = useState()
    const [trabMasc, setTrabMasc]: any = useState()
    const [trabFem, setTrabFem]: any = useState()

    // States para CRUD de risco
    const [riscos, setRiscos] = useState([])
    const [riscoSelecionado, setRiscoSelecionado]: any = useState()
    const [categorias, setCategorias] = useState([])
    const [categoriaSelecionada, setCategoriaSelecionada]: any = useState()
    const [nomeNovoRisco, setNomeNovoRisco]: any = useState()

    // States para CRUD de exames
    const [exames, setExames] = useState([])
    const [exameSelecionado, setExameSelecionado]: any = useState();
    const [valor, setValor] = useState<string | undefined>()
    // Estados para armazenar o valor de cada checkbox
    const [admissional, setAdmissional] = useState(false);
    const [demissional, setDemissional] = useState(false);
    const [retornoTrabalho, setRetornoTrabalho] = useState(false);
    const [mudancaRisco, setMudancaRisco] = useState(false);
    const [posAdmissional, setPosAdmissional] = useState<number>(0);
    const [periodico, setPeriodico] = useState(0);
    const [periodicoAPartir, setPeriodicoAPartir] = useState(0);
    const [periodicoAte, setPeriodicoAte] = useState(0);
    const [periodicoAntes, setPeriodicoAntes] = useState(0);
    const [periodicoDepois, setPeriodicoDepois] = useState(0);

    // Itens cadastrados
    const [examesIncluidos, setExamesIncluidos]: any = useState([]);
    const [riscosIncluidos, setRiscosIncluidos]: any = useState([]);
    const [funcoesIncluidas, setFuncoesIncluidas]: any = useState([]);

    const [selectedFuncoes, setSelectedFuncoes] = useState<number[]>([]);
    const [selectedRiscos, setSelectedRiscos] = useState<number[]>([]);
    const [selectedExames, setSelectedExames] = useState<number[]>([]);

    const [funcoesEditadas, setFuncoesEditadas] = useState<any[]>([]);
    const [examesEditados, setExamesEditados] = useState<any[]>([]);
    const [isEditingExames, setIsEditingExames] = useState(false);
    const [isEditingFuncoes, setIsEditingFuncoes] = useState(false);
    const [examesNormalizados, setExamesNormalizados] = useState<any[]>([]);
    const [funcoesNormalizadas, setFuncoesNormalizadas] = useState<any[]>([]);
    
    const [uf, setUf]: any = useState('');
    const [crm, setCRM]: any = useState('');
    const [nomeMedico, setNomeMedico]: any = useState('');

    const currentPath = location.pathname.toLocaleUpperCase().replace('/', '');

    const ufs = [
        { id: 1, nome: 'AC' },
        { id: 2, nome: 'AL' },
        { id: 3, nome: 'AM' },
        { id: 4, nome: 'AP' },
        { id: 5, nome: 'BA' },
        { id: 6, nome: 'CE' },
        { id: 7, nome: 'DF' },
        { id: 8, nome: 'ES' },
        { id: 9, nome: 'GO' },
        { id: 10, nome: 'MA' },
        { id: 11, nome: 'MG' },
        { id: 12, nome: 'MS' },
        { id: 13, nome: 'MT' },
        { id: 14, nome: 'PA' },
        { id: 15, nome: 'PB' },
        { id: 16, nome: 'PE' },
        { id: 17, nome: 'PI' },
        { id: 18, nome: 'PR' },
        { id: 19, nome: 'RJ' },
        { id: 20, nome: 'RN' },
        { id: 21, nome: 'RO' },
        { id: 22, nome: 'RR' },
        { id: 23, nome: 'RS' },
        { id: 24, nome: 'SC' },
        { id: 25, nome: 'SE' },
        { id: 26, nome: 'SP' },
        { id: 27, nome: 'TO' }
    ];
     
    // Controlar a visibilidade das colunas
    const [visibleColumns, setVisibleColumns] = useState({
        col1: true,
        col2: true,
        col3: true,
    });
    
    
    // Controlar a visibilidade das colunas
    const [minimizedColumns, setMinimizedColumns]: any = useState({
        col1: false,
        col2: false,
        col3: false,
    });
    
    useEffect(() => {
        const fetchData = async () => {
            await handleListCompany();
            await handleListItens()
        };
        
        fetchData();
    }, [idEmpresa]);
    
    // Função para lidar com as mudanças dos checkboxes
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, setState: React.Dispatch<React.SetStateAction<boolean>>) => {
        setState(event.target.checked);
    };

    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };
    
    // Método para desminimizar colunas
    const handleToggleMinimize = (col: any) => {
        setMinimizedColumns((prev: any) => ({
            ...prev,
            [col]: !prev[col],
        }));
    };
    
    // Método para minimizar/maximizar colunas
    const handleToggle = (col: any) => {
        if (minimizedColumns[col]) {
            handleToggleMinimize(col);
        }
        setMinimizedColumns((prev: any) => ({
            ...prev,
            [col]: !prev[col],
        }));
    };
    
    const handleVigenciaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVigenciaSelecionada(e.target.value);
    };

    // Método para identificar o tamanho que a coluna deve ficar
    const getColumnSize = () => {
        const totalColumns = Object.keys(visibleColumns).length;
        const minimizedCount = Object.values(minimizedColumns).filter(Boolean).length;
        const visibleCount = totalColumns - minimizedCount;

        if (minimizedCount === 1) {
            return 5
        }
        if (minimizedCount === 2) {
            return 8
        } else {
            return 4;
        }
    };


    // Buscar itens da empresa - Revisão/GHE
    const handleListItens = async () => {
        try {
            const response = await api.get(`buscar-itens-empresa/${idEmpresa}`)
            const responseData = response.data;
            setRevisoes(responseData.dataRevisao)
            setGhes(responseData.dataGhe)
            setCategorias(responseData.dataCategoriasRiscos)

            if (responseData.dataGhe.length > 0) {
                setGheSelecionado(responseData.dataGhe.id[0])
            }
        } catch (error) {
            console.error(error)
        }
    }


    // Buscar dados da empresa logada
    const handleListCompany = async () => {
        try {
            const response = await api.post('listar-empresa-aso');
            setEmpresa(response.data.empresa);
            setIdEmpresa(response.data.empresa.id);
        } catch (error) {
            console.log(error)
        }
    }

    // Buscar exames para o AutoComplete
    const handleListExams = async (inputValue: any) => {
        if (inputValue.length >= 1) {
            const response = await api.get(`listar-exames-tab-balcao-emp/${idEmpresa}/${inputValue}`);
            const responseData = response.data
            setExames(responseData);
        } else {
            setExames([])
        }
    }

    // Buscar funções para o AutoComplete
    const handleListFunction = async (inputValue: any) => {
        if (inputValue.length > 1) {
            const response = await api.get(`funcionarios/buscar-funcao/${inputValue}`);
            const responseData = response.data;
            setFuncoes(responseData);
        } else {
            setFuncoes([]);
        }
    };


    // Buscar riscos para o AutoComplete
    const handleListRisk = async (inputValue: any) => {
        if (inputValue.length > 1) {
            try {
                const encodedValue = encodeURIComponent(inputValue);
                const response = await api.get(`buscar-riscos/${encodedValue}`);
                setRiscos(response.data);
            } catch (error) {
                console.error('Erro ao buscar riscos', error);
                setAlert({ show: true, message: 'Erro ao buscar riscos. Tente novamente!', variant: 'danger' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setRiscos([]);
        }
    };

    const handleAddFunction = async () => {
        if (!funcaoSelecionada || !funcaoSelecionada.cbo || !descricaoFuncao || !trabMasc || !trabFem) {
            setAlert({ show: true, message: 'Preencha todos os campos antes de incluir a função!', variant: 'warning' });
            return; 
        }

        const isFuncaoIncluida = funcoesIncluidas.some((f: { id_funcao: any; }) => f.id_funcao === funcaoSelecionada.id);

        if (!isFuncaoIncluida) {
            const novaFuncao = {
                ...funcaoSelecionada,
                id_funcao: funcaoSelecionada.id,
                cbo: cbo || funcaoSelecionada.cbo,
                descricaoFuncao: descricaoFuncao,
                trabMasculino: trabMasc,
                trabFeminino: trabFem
            };

            setFuncoesIncluidas((prevFuncoes: any) => [...prevFuncoes, novaFuncao]);
            setFuncoesNormalizadas((prevFuncoes: any) => [...prevFuncoes, novaFuncao]);
            setFuncaoSelecionada(null);
            setCbo('');
            setCboValue('');
            setDescricaoFuncao('');
            setTrabMasc('');
            setTrabFem('');
        } else {
            // Exibe alerta caso a função já esteja incluída
            setAlert({ show: true, message: 'Função já incluída!', variant: 'warning' });
        }
    };

    const handleAddRisk = async () => {
        if (!riscoSelecionado && !inserirRiscoManual) {
            setAlert({ show: true, message: 'É necessário selecionar um risco!', variant: 'warning' });
            return; 
        }
    
        if (inserirRiscoManual && (!nomeNovoRisco || !categoriaSelecionada)) {
            setAlert({ show: true, message: 'É necessário preencher o nome e a categoria do novo risco!', variant: 'warning' });
            return; 
        }

        const isRiscoIncluido = inserirRiscoManual
            ? riscosIncluidos.some((f: { nome: string }) => f.nome === nomeNovoRisco)
            : riscosIncluidos.some((f: { id_risco: any }) => f.id_risco === riscoSelecionado.id);

        if (!isRiscoIncluido) {
            let novoRisco: any;
            if (inserirRiscoManual) {
                novoRisco = {
                    nome: nomeNovoRisco,
                    AteBaseRiscosCat: categoriaSelecionada,
                    // opcional: adicionar um id temporário ou aleatório se necessário
                    // id: new Date().getTime(), // gera um id temporário
                };
            } else {
                novoRisco = {
                    ...riscoSelecionado
                };
            }
            setRiscosIncluidos((prevRiscos: any) => [...prevRiscos, novoRisco]);
            setRiscoSelecionado('');
            setNomeNovoRisco('');
        } else {
            setAlert({ show: true, message: 'Risco já incluído!', variant: 'warning' });
        }
    };

    const handleAddExame = async () => {
        if (!exameSelecionado || !valor) {
            setAlert({ show: true, message: 'Preencha todos os campos antes de incluir o exame!', variant: 'warning' });
            return; 
        }
        if (!examesIncluidos.some((f: { id_exame: any; }) => f.id_exame === exameSelecionado.id)) {
            const novoExame = {
                ...exameSelecionado,
                id_exame: exameSelecionado.id,
                admissional: admissional ? admissional : false,
                demissional: demissional ? demissional : false,
                retorno: retornoTrabalho ? retornoTrabalho : false,
                mudanca_risco: mudancaRisco ? mudancaRisco : false,
                pos_admissional: posAdmissional,
                periodicidade: periodico,
                per_id1: periodicoAPartir,
                per_id2: periodicoAte,
                periodicidade_a: periodicoAntes,
                periodicidade_d: periodicoDepois,
                valor: valor
            };
            setExamesIncluidos((prevExames: any) => [...prevExames, novoExame]);
            setExamesNormalizados((prevExames: any) => [...prevExames, novoExame]);
            setExameSelecionado(null);
            setValor(''); 
            setAdmissional(false);
            setDemissional(false);
            setRetornoTrabalho(false);
            setMudancaRisco(false);
            setPosAdmissional(0);
            setPeriodico(0);
            setPeriodicoAPartir(0);
            setPeriodicoAte(0);
            setPeriodicoAntes(0);
            setPeriodicoDepois(0);

        } else {
            setAlert({ show: true, message: 'Exame já incluído!', variant: 'warning' });
        }
    }

    const handleGheChange = (e: any) => {
        const selectedValue = e.target.value;
        if (selectedValue === 'novo') {
            setShowGheModal(true);
        } else {
            setGheSelecionado(selectedValue);
        }
    };

    const handleCreateGhe = async () => {
        const nomeGheElement = document.querySelector('#formNomeGhe') as HTMLInputElement | null;
        const nomeGhe = nomeGheElement ? nomeGheElement.value : '';
        if (nomeGhe === '') {
            setAlert({ show: true, message: 'Preencha o nome do GHE!', variant: 'warning' });
            return;
        }
        try {
            const response = await api.post('criar-ghe-reaproveitamento-pcmso', {
                id_empresa: idEmpresa,
                nome: nomeGhe
            });
            setAlert({ show: true, message: response.data.message, variant: 'success' });
            setShowGheModal(false);
            handleListItens();        
            setGheSelecionado(response.data.result.gheReaproveitamentoPcmso.id);
        } catch (error) {
            console.error('Erro ao salvar GHE', error);
            setAlert({ show: true, message: 'Erro ao salvar GHE. Tente novamente!', variant: 'danger' });
        }
    }

    
    const handleSaveReaproveitamento = async () => {
        if (gheSelecionado === '' || gheSelecionado === undefined) {
            setAlert({ show: true, message: 'Selecione uma GHE!', variant: 'warning' });
            return;
        }
        if (nomeMedico === '' || crm === '' || uf === '') {
            setAlert({ show: true, message: 'Preencha todos os campos do médico coordenador!', variant: 'warning' });
            return;
        }

        if (selectedFile === null) {
            setAlert({ show: true, message: 'Por favor insira um PCMSO!', variant: 'warning' });
            return;
        }

        const vigenciaFormatada = `${vigenciaSelecionada}-01`;

        const formData = new FormData();
        if (selectedFile) {
            formData.append('file', selectedFile, selectedFileName);
            formData.append('fileName', selectedFileName);
        }
        formData.append('idEmpresa', idEmpresa?.toString() || '');
        formData.append('routeName', currentPath);
        formData.append('idRevisao', revisaoSelecionada ? revisaoSelecionada.id : null);
        formData.append('idGhe', gheSelecionado);
        formData.append('funcoes', JSON.stringify(funcoesIncluidas));
        formData.append('riscos', JSON.stringify(riscosIncluidos));
        formData.append('exames', JSON.stringify(examesIncluidos));
        formData.append('data_vigencia', vigenciaFormatada);
        formData.append('nome_medico', nomeMedico);
        formData.append('crm_medico', crm);
        formData.append('uf_crm', uf);

        setLoadingSave(true);
        try {
            const response = await api.post('salvar-reaproveitamento-pcmso', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setAlert({ show: true, message: response.data.message, variant: 'success' });
            setExamesIncluidos([]);
            setFuncoesIncluidas([]);
            setRiscosIncluidos([]);
            setSelectedFile(null);
            setSelectedFileName('');
        } catch (error) {
            console.error('Erro ao salvar reaproveitamento', error);
            setAlert({ show: true, message: 'Erro ao salvar reaproveitamento. Tente novamente!', variant: 'danger' });
        } finally {
            setLoadingSave(false);
        }
    }
    
    const handleFileSelection = (event: any) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type === "application/pdf") {
                setSelectedFile(file);
                setSelectedFileName(file.name);
            } else {
                setAlert({ show: true, message: 'Por favor, anexe apenas arquivos no formato PDF.', variant: 'warning' });
                event.target.value = ""; 
            }
        }
    };
    

    const removeSelectedFile = () => {
        setSelectedFile(null);
        setSelectedFileName('');
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setCboValue(newValue);
        setCbo(newValue);
    };

    const handleSelectFuncao = (id: number) => {
        if (selectedFuncoes.includes(id)) {
            setSelectedFuncoes(selectedFuncoes.filter(funcaoId => funcaoId !== id));
        } else {
            setSelectedFuncoes([...selectedFuncoes, id]);
        }
    };

    const handleSelectRiscos = (id: number) => {
        if (selectedRiscos.includes(id)) {
            setSelectedRiscos(selectedRiscos.filter(riscoId => riscoId !== id));
        } else {
            setSelectedRiscos([...selectedRiscos, id]);
        }
    };

    const handleSelectExames = (id: number) => {
        if (selectedExames.includes(id)) {
            setSelectedExames(selectedExames.filter(exameId => exameId !== id));
        } else {
            setSelectedExames([...selectedExames, id]);
        }
    };

    const handleEditExames = () => {
        setMinimizedColumns({ col1: true, col2: true, col3: false });
        setIsEditingExames(!isEditingExames);
    };

    const handleEditFuncoes = () => {
        setMinimizedColumns({ col1: false, col2: true, col3: true });
        setIsEditingFuncoes(true);
    };

    const handleDeleteFuncoes = () => {
        const updatedFuncoes = funcoesIncluidas.filter((funcao: { id: number }) => !selectedFuncoes.includes(funcao.id));
        setFuncoesIncluidas(updatedFuncoes);
        setFuncoesNormalizadas(updatedFuncoes); 
        setSelectedFuncoes([]);
    };

    const handleDeleteRiscos = () => {
        const updatedRiscos = riscosIncluidos.filter((risco: { id: number }) => !selectedRiscos.includes(risco.id));
        setRiscosIncluidos(updatedRiscos);
        setSelectedRiscos([]);
    };

    const handleDeleteExames = () => {
        const updatedExames = examesIncluidos.filter((exame: { id: number }) => !selectedExames.includes(exame.id));
        setExamesIncluidos(updatedExames);
        setExamesNormalizados(updatedExames);
        setSelectedExames([]);
    };
    
    const handleEditFuncao = (funcaoId: number, campo: string, valor: any) => {
        const updatedFuncoes = funcoesIncluidas.map((funcao: any) => {
            if (funcao.id === funcaoId) {
                return { ...funcao, [campo]: valor };
            }
            return funcao;
        });
        setFuncoesIncluidas(updatedFuncoes);
    }

    const handleEditExame = (id: number, field: string, value: any) => {
        const updatedExames = examesIncluidos.map((exame: any) => {
            if (exame.id === id) {
                return { ...exame, [field]: value };
            }
            return exame;
        });
        setExamesIncluidos(updatedExames);
    };

    const handleSaveEdicoesFuncoes = () => {
        setMinimizedColumns({ col1: false, col2: false, col3: false });
        setIsEditingFuncoes(false);
        setSelectedFuncoes([]);
    };

    const handleSaveEdicoesExames = () => {
        setMinimizedColumns({ col1: false, col2: false, col3: false });
        setIsEditingExames(false);
        setSelectedExames([]);
    };

    const handleCancelEdicoesFuncoes = () => {
        setMinimizedColumns({ col1: false, col2: false, col3: false });
        setIsEditingFuncoes(false);
        setFuncoesIncluidas(funcoesNormalizadas);
        setSelectedFuncoes([]);
    };

    const handleCancelEdicoesExames = () => {
        setMinimizedColumns({ col1: false, col2: false, col3: false });
        setIsEditingExames(false);
        setExamesIncluidos(examesNormalizados);
        setSelectedExames([]);
    };

    const handleSelectAllExames = () => {
        if (selectedExames.length === examesIncluidos.length) {
          setSelectedExames([]);
        } else {
          const allExamesIds = examesIncluidos.map((exame: any) => exame.id);
          setSelectedExames(allExamesIds);
        }
    };
    
    const handleSelectAllFuncoes = () => {
        if (selectedFuncoes.length === funcoesIncluidas.length) {
          setSelectedFuncoes([]);
        } else {
          const allFuncoesIds = funcoesIncluidas.map((funcao: any) => funcao.id);
          setSelectedFuncoes(allFuncoesIds);
        }
    };

    const handleSelectAllRiscos = () => {
        if (selectedRiscos.length === riscosIncluidos.length) {
          setSelectedRiscos([]);
        } else {
          const allRiscosIds = riscosIncluidos.map((risco: any) => risco.id);
          setSelectedRiscos(allRiscosIds);
        }
    };

    const fetchGheInformation = async () => {
        if (gheSelecionado) {
            const response = await api.get(`buscar-infos-ghe-reap-pcmso/${idEmpresa}/${gheSelecionado}`);
            const responseData = response.data;
            setFuncoesIncluidas(responseData.funcoesGhe);
            setRiscosIncluidos(responseData.riscosGhe);
            setExamesIncluidos(responseData.examesGhe);
        }
    };

    useEffect(() => {
        fetchGheInformation();
        console.log('funcoesIncluidas', funcoesIncluidas);
        console.log('gheSelecionado', gheSelecionado);
    }, [gheSelecionado]);

    useEffect(() => {
        if (funcaoSelecionada?.cbo) {
            setCboValue(funcaoSelecionada.cbo);
        }
    }, [funcaoSelecionada]);

    useEffect(() => {
        if (isEditingFuncoes) {
            const funcoesParaEditar = funcoesIncluidas.filter((funcao: any) =>
                selectedFuncoes.includes(funcao.id)
            );
            setFuncoesEditadas(funcoesParaEditar);
        }
    }, [isEditingFuncoes, selectedFuncoes, funcoesIncluidas]);

    useEffect(() => {
        if (isEditingExames) {
            const examesParaEditar = examesIncluidos.filter((exame: any) =>
                selectedExames.includes(exame.id)
            );
            setExamesEditados(examesParaEditar);
        }
    }, [isEditingExames, selectedExames, examesIncluidos]);


    return (
        <>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <div style={{ display: 'flex', height: '27vh', marginBottom: '10px' }}>
                    <CardContent style={{ width: '50%', padding: '20px', textAlign: 'center', position: 'relative' }}>
                        <h5 style={{ color: '#0463C1', marginBottom: '20px', fontSize: '1.25rem' }}>
                            Aso por PCMSO
                        </h5>
                        <hr style={{ border: '1px solid #0463C1', marginBottom: '20px' }} />

                        <Row className="d-flex justify-content-between">
                            <Col xs={12} md={4}>
                                <Form.Group as={Row} controlId="formGhe" className="mb-3" style={{ alignItems: 'center' }}>
                                    <Form.Label column xs="auto" style={{ fontSize: '1rem', paddingRight: '0.5rem' }}>
                                        GHE (<span style={{ color: 'red' }}>Setor</span>):
                                    </Form.Label>
                                    <Col>
                                        <Form.Control
                                            as="select"
                                            name="ghe"
                                            value={gheSelecionado}
                                            size="lg"
                                            style={{
                                                padding: '0.4rem 0.6rem',
                                                fontSize: '0.9rem',
                                                border: '1px solid #0463C1',
                                                display: 'inline-block',
                                                width: '100%',
                                                borderRadius: '5px',
                                            }}
                                            onChange={handleGheChange}
                                        >
                                            <option value="">Selecione uma GHE</option>
                                            <hr/>
                                            <option value="novo">Inserir novo GHE</option>
                                            <hr/>
                                            {ghes.map((ghe: any) => (
                                                <option key={ghe.id} value={ghe.id}>
                                                    {ghe.nome}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={8} className="d-flex justify-content-end">
                                {selectedFileName ? (
                                    <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0463C1', borderRadius: '5px', padding: '5px 10px', backgroundColor: '#f9f9f9' }}>
                                        <AttachFileIcon style={{ color: '#0463C1', marginRight: '10px' }} />
                                        <span style={{ flex: 1, color: '#0463C1' }}>{selectedFileName}</span>
                                        <Button variant="danger" onClick={removeSelectedFile} style={{ marginLeft: '10px', padding: '5px 10px' }}>
                                            <CloseIcon />
                                        </Button>
                                    </div>
                                ) : (
                                    <Button onClick={() => setShowAttachModal(true)} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', backgroundColor: '#0463C1', color: '#fff', borderRadius: '5px' }}>
                                        <AttachFileIcon style={{ marginRight: '5px' }} />
                                        Anexar PCMSO
                                    </Button>
                                )}
                            </Col>

                            <Modal show={showAttachModal} onHide={() => setShowAttachModal(false)}>
                                <Modal.Header closeButton></Modal.Header>
                                <Modal.Body>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        style={{ display: "none" }}
                                        onChange={handleFileSelection}
                                    />
                                    <label
                                        htmlFor="fileInput"
                                        style={{
                                            border: "2px dashed #0d6efd",
                                            padding: "40px",
                                            display: "block",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                            cursor: "pointer",
                                            color: "#0d6efd",
                                            borderRadius: "4px",
                                            margin: "20px 0",
                                        }}
                                    >
                                        {selectedFileName
                                            ? `Arquivo selecionado: ${selectedFileName}`
                                            : "Clique ou arraste o arquivo aqui"}
                                    </label>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Button
                                            variant="secondary"
                                            onClick={() => setShowAttachModal(false)}
                                            style={{ marginRight: "10px" }}
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ background: "#009900", color: "#fff" }}
                                            onClick={() => { setShowAttachModal(false); }}
                                        >
                                            Inserir
                                        </Button>
                                    </Box>
                                </Modal.Footer>
                            </Modal>
                        </Row>

                        {/* Campo para Data de Vigência do PCMSO */}
                        <Row className="d-flex justify-content-start">
                            <Col xs={12} md={4}>
                                <Form.Group as={Row} controlId="formVigencia" className="mb-3" style={{ alignItems: 'center' }}>
                                    <Form.Label column xs="auto" style={{ fontSize: '1rem', paddingRight: '0.5rem' }}>
                                        Data de Vigência do PCMSO:
                                    </Form.Label>
                                    <Col>
                                        <Form.Control
                                            type="month"
                                            name="vigencia"
                                            value={vigenciaSelecionada}
                                            min={DateTime.now().toFormat('yyyy-MM')}
                                            size="lg"
                                            style={{
                                                padding: '0.4rem 0.6rem',
                                                fontSize: '0.9rem',
                                                border: '1px solid #0463C1',
                                                display: 'inline-block',
                                                width: '100%',
                                                borderRadius: '5px',
                                            }}
                                            onChange={(e: any) => setVigenciaSelecionada(e.target.value)}
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Modal show={showGheModal} onHide={() => setShowGheModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Inserir novo GHE</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form.Group controlId="formNomeGhe" className="mb-3">
                                    <Form.Label style={{ fontSize: '1rem', paddingRight: '0.5rem' }}>Nome do GHE:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nomeGhe"
                                        size="lg"
                                        style={{
                                            padding: '0.4rem 0.6rem',
                                            fontSize: '0.9rem',
                                            border: '1px solid #0463C1',
                                            borderRadius: '5px',
                                        }}
                                    />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowGheModal(false)}>
                                    Fechar
                                </Button>
                                <Button variant="primary" onClick={handleCreateGhe}>
                                    Inserir
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </CardContent>
                </div>
                <div style={{ display: 'flex', height: '20vh', marginBottom: '30px' }}>
                    <CardContent style={{ width: '50%', padding: '20px', textAlign: 'center', position: 'relative' }}>
                    <Row style={{ marginTop: '10px' }}>
                                <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações do Médico Coordenador</h6>
                            </Row>
                            <Row>
                                <Col xs={12} md={4} xl={4}>
                                    <FormGroup>
                                        <Label title='Nome do Médico' htmlFor={''} />
                                        <input type='text' style={{ width: '100%' }} value={nomeMedico} onChange={(e: any) => setNomeMedico(e.target.value)} />
                                    </FormGroup>

                                </Col>
                                <Col xs={12} md={4} xl={4}>
                                    <FormGroup>
                                        <Label title='CRM do Médico' htmlFor={''} />
                                        <input type='text' style={{ width: '100%' }} value={crm} onChange={(e: any) => setCRM(e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={4} xl={4}>
                                    <Label title='UF CRM do Médico' htmlFor={''} />
                                    <Select id="selectResponsavel" value={uf} onSelect={(uf: {id: number, nome: string}) => { setUf(uf)}}>
                                        {ufs.map((tipo: any) => (
                                            <Options
                                                key={tipo.id}
                                                value={tipo.nome}
                                                name={tipo.nome} />
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                    </CardContent>
                </div>
                <Card>
                    <Card.Body>
                        <Container fluid>
                            <Row>
                                {/* Coluna 1 */}
                                {visibleColumns.col1 && (
                                    <Col
                                        xs={12}
                                        md={minimizedColumns.col1 && Object.values(minimizedColumns).filter(Boolean).length < 3 ? 2 : getColumnSize()}
                                        style={{
                                            transition: 'all 0.3s ease'
                                        }}
                                        onClick={() => minimizedColumns.col1 && handleToggleMinimize('col1')}
                                    >
                                        <div
                                            style={{
                                                borderRight: '1px solid #ddd',
                                                padding: '10px',
                                                position: 'relative',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: minimizedColumns.col1 ? 'ellipsis' : 'clip',
                                                cursor: minimizedColumns.col1 ? 'pointer' : 'default'
                                            }}
                                        >
                                            {!minimizedColumns.col1 && (
                                                <Button
                                                    variant="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleToggle('col1');
                                                    }}
                                                    style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '0.7rem' }}
                                                >
                                                    Ocultar
                                                </Button>
                                            )}
                                            {!minimizedColumns.col1 ? (
                                                <>
                                                    <h6>Funções</h6>
                                                    <hr />
                                                    <Card style={{
                                                        border: '1px solid #0d6efd',
                                                        borderRadius: '8px',
                                                        height: '350px'
                                                    }}>
                                                        <Card.Body style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                            <h6>Inserir nova função:</h6>
                                                            <Form.Group as={Row} controlId="formNomeFuncao" className="mb-1 align-items-center">
                                                                <Form.Label column sm={5} style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                                                                    Nome (digite e selecione):
                                                                </Form.Label>
                                                                <Col sm={7}>
                                                                    <Autocomplete
                                                                        value={funcaoSelecionada || null} 
                                                                        onChange={(event, newValue: any) => {
                                                                            if (event) {
                                                                                event.preventDefault();
                                                                            }
                                                                            setFuncaoSelecionada(newValue);
                                                                        }}
                                                                        onInputChange={(event, newInputValue) => {
                                                                            if (event) {
                                                                                event.preventDefault();
                                                                            }
                                                                            handleListFunction(newInputValue);
                                                                        }}
                                                                        size='small'
                                                                        noOptionsText="Digite e selecione"
                                                                        getOptionLabel={(option) => option ? option.nome : ""}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                label=""
                                                                                size="small"
                                                                                style={{
                                                                                    padding: '0.2rem 0.4rem',
                                                                                    fontSize: '0.75rem',
                                                                                    border: '1px solid #0d6efd',
                                                                                    borderRadius: '8px',
                                                                                    margin: 0,
                                                                                }}
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    style: {
                                                                                        padding: '0.2rem 0.4rem',
                                                                                        fontSize: '0.75rem',
                                                                                    },
                                                                                }}
                                                                            />
                                                                        )}
                                                                        options={funcoes.length > 0 ? funcoes : funcao}
                                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formCbo" className="mb-1 align-items-center">
                                                                <Form.Label column sm={5} style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                                                                    CBO:
                                                                </Form.Label>
                                                                <Col sm={7}>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="cbo"
                                                                        value={cboValue}
                                                                        onChange={handleInputChange}
                                                                        size="sm"
                                                                        style={{
                                                                            padding: '0.2rem 0.4rem',
                                                                            fontSize: '0.75rem',
                                                                            border: '1px solid #0d6efd'
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formDescricaoFuncao" className="mb-1 align-items-center">
                                                                <Form.Label column sm={5} style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                                                                    Descrição:
                                                                </Form.Label>
                                                                <Col sm={7}>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        rows={2}
                                                                        name="descricaoFuncao"
                                                                        value={descricaoFuncao}
                                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setDescricaoFuncao(event.target.value)}
                                                                        size="sm"
                                                                        style={{
                                                                            padding: '0.2rem 0.4rem',
                                                                            fontSize: '0.75rem',
                                                                            resize: 'vertical',
                                                                            border: '1px solid #0d6efd'
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formTraMasculino" className="mb-1 align-items-center">
                                                                <Form.Label column sm={5} style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                                                                    Nº Tra. Masculino:
                                                                </Form.Label>
                                                                <Col sm={7}>
                                                                    <Form.Control
                                                                        type="number"
                                                                        name="traMasculino"
                                                                        value={trabMasc}
                                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setTrabMasc(event.target.value)}
                                                                        size="sm"
                                                                        style={{
                                                                            padding: '0.2rem 0.4rem',
                                                                            fontSize: '0.75rem',
                                                                            border: '1px solid #0d6efd'
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formTraFeminino" className="mb-1 align-items-center">
                                                                <Form.Label column sm={5} style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                                                                    Nº Tra. Feminino:
                                                                </Form.Label>
                                                                <Col sm={7}>
                                                                    <Form.Control
                                                                        type="number"
                                                                        name="traFeminino"
                                                                        value={trabFem}
                                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setTrabFem(event.target.value)}
                                                                        size="sm"
                                                                        style={{
                                                                            padding: '0.2rem 0.4rem',
                                                                            fontSize: '0.75rem',
                                                                            border: '1px solid #0d6efd'
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Row className="mt-auto">
                                                                <Col md={12} className="d-flex justify-content-center">
                                                                    <Button
                                                                        variant="primary"
                                                                        size="sm"
                                                                        style={{
                                                                            width: '20%'
                                                                        }}
                                                                        onClick={() => handleAddFunction()}
                                                                    >
                                                                        Inserir
                                                                    </Button>
                                                                </Col>
                                                            </Row>

                                                        </Card.Body>
                                                    </Card>
                                                    <Row className="mt-3">
                                                        <Col md={12} className="d-flex justify-content-center">
                                                            <h6>Funções cadastradas</h6>
                                                        </Col>
                                                    </Row>
                                                    <table style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', borderCollapse: 'separate', borderSpacing: '0' }}>
                                                        <thead>
                                                            <tr style={{ backgroundColor: '#0d6efd', color: 'white', height: '8px' }}>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', width: '30%', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Nome</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>CBO</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Descrição</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Nº Mas.</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Nº Fem.</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Total</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    style={{ accentColor: '#ffffff' }}
                                                                    checked={selectedFuncoes.length === funcoesIncluidas.length && funcoesIncluidas.length > 0}
                                                                    onChange={handleSelectAllFuncoes}
                                                                />
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {funcoesIncluidas.map((funcao: any, index: number) => {
                                                                return (
                                                                    <tr key={funcao.id} style={{ height: '25px' }}>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', width: '30%', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {funcao.nome}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingFuncoes && selectedFuncoes.includes(funcao.id) ? (
                                                                                <Form.Control
                                                                                type="text"
                                                                                name="cboEdit"
                                                                                value={funcao.cbo}
                                                                                onChange={(e) => handleEditFuncao(funcao.id, 'cbo', e.target.value)}
                                                                                size="sm"
                                                                                style={{
                                                                                    padding: '0.2rem 0.4rem',
                                                                                    fontSize: '0.75rem',
                                                                                    border: '1px solid #0d6efd',
                                                                                    maxWidth: '100px'
                                                                                }}
                                                                                />
                                                                            ) : (
                                                                                funcao.cbo
                                                                            )}
                                                                          
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingFuncoes && selectedFuncoes.includes(funcao.id) ? (
                                                                                <Form.Control
                                                                                type="text"
                                                                                name="descriFuncao"
                                                                                value={funcao.descricaoFuncao}
                                                                                onChange={(e) => handleEditFuncao(funcao.id, 'descricaoFuncao', e.target.value)}
                                                                                size="sm"
                                                                                style={{
                                                                                    padding: '0.2rem 0.4rem',
                                                                                    fontSize: '0.75rem',
                                                                                    border: '1px solid #0d6efd',
                                                                                    maxWidth: '180px'
                                                                                }}
                                                                                />
                                                                                ) : 
                                                                                 funcao.descricaoFuncao
                                                                            }
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingFuncoes && selectedFuncoes.includes(funcao.id) ? (
                                                                                <Form.Control
                                                                                type="number"
                                                                                name="trabMasculino"
                                                                                value={funcao.trabMasculino}
                                                                                onChange={(e) => handleEditFuncao(funcao.id, 'trabMasculino', e.target.value)}
                                                                                size="sm"
                                                                                style={{
                                                                                    padding: '0.2rem 0.4rem',
                                                                                    fontSize: '0.75rem',
                                                                                    border: '1px solid #0d6efd',
                                                                                    maxWidth: '100px'
                                                                                }}
                                                                            />
                                                                            ) : 
                                                                                funcao.trabMasculino
                                                                            }
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingFuncoes && selectedFuncoes.includes(funcao.id) ? (
                                                                                <Form.Control
                                                                                type="number"
                                                                                name="traFeminino"
                                                                                value={funcao.trabFeminino}
                                                                                onChange={(e) => handleEditFuncao(funcao.id, 'trabFeminino', e.target.value)}
                                                                                size="sm"
                                                                                style={{
                                                                                    padding: '0.2rem 0.4rem',
                                                                                    fontSize: '0.75rem',
                                                                                    border: '1px solid #0d6efd',
                                                                                    maxWidth: '100px'
                                                                                }}
                                                                                />
                                                                            ) : 
                                                                                funcao.trabFeminino
                                                                            }
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {Number(funcao.trabMasculino) + Number(funcao.trabFeminino)}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ accentColor: '#ffffff' }}
                                                                            checked={selectedFuncoes.includes(funcao.id)}
                                                                            onChange={() => handleSelectFuncao(funcao.id)}
                                                                        />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    <div className="mt-3 d-flex justify-content-center">
                                                    {isEditingFuncoes ? (
                                                                <>
                                                                    <Button variant="danger" className='mx-2' onClick={handleCancelEdicoesFuncoes} disabled={selectedFuncoes.length === 0}>Cancelar</Button>
                                                                    <Button variant="primary" onClick={handleSaveEdicoesFuncoes} disabled={selectedFuncoes.length === 0}>
                                                                        Salvar
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Button variant="danger" className='mx-2' onClick={handleDeleteFuncoes} disabled={selectedFuncoes.length === 0}>Excluir</Button>
                                                                    <Button variant="primary" onClick={handleEditFuncoes} disabled={selectedFuncoes.length === 0}>
                                                                       Editar
                                                                    </Button>
                                                                </>

                                                            )}
                                                    </div>
                                                    
                                                </>
                                            ) : (
                                                <div style={{ textAlign: 'center' }}><Button>Funções</Button></div>
                                            )}
                                        </div>
                                    </Col>
                                )}

                                {/* Coluna 2 */}
                                {visibleColumns.col2 && (
                                    <Col
                                        xs={12}
                                        md={minimizedColumns.col2 && Object.values(minimizedColumns).filter(Boolean).length < 3 ? 2 : getColumnSize()}
                                        style={{
                                            transition: 'all 0.3s ease',
                                        }}
                                        onClick={() => minimizedColumns.col2 && handleToggleMinimize('col2')}
                                    >
                                        <div
                                            style={{
                                                borderRight: '1px solid #ddd',
                                                padding: '10px',
                                                position: 'relative',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: minimizedColumns.col2 ? 'ellipsis' : 'clip',
                                                cursor: minimizedColumns.col2 ? 'pointer' : 'default'
                                            }}
                                        >
                                            {!minimizedColumns.col2 && (
                                                <Button
                                                    variant="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleToggle('col2');
                                                    }}
                                                    style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '0.7rem' }}
                                                >
                                                    Ocultar
                                                </Button>
                                            )}
                                            {!minimizedColumns.col2 ? (
                                                <>
                                                    <>
                                                        <h6>Riscos</h6>
                                                        <hr />
                                                        <Card style={{
                                                            border: '1px solid #0d6efd',
                                                            borderRadius: '8px',
                                                            height: '350px'
                                                        }}>
                                                            <Card.Body style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                                <Row className="align-items-center">
                                                                    <Col md="auto" className="d-flex align-items-center">
                                                                        <h6 style={{ marginBottom: '0' }}>Inserir novo risco:</h6>
                                                                    </Col>
                                                                    <Col className="d-flex align-items-center justify-content-end">
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                id="inserir-manualmente"
                                                                                checked={inserirRiscoManual}
                                                                                onChange={(e) => {
                                                                                    setInserirRiscoManual(e.target.checked);
                                                                                    setRiscoSelecionado(null)
                                                                                }}
                                                                                style={{ marginRight: '0.5rem' }}
                                                                            />
                                                                            <label htmlFor="inserir-manualmente" style={{ margin: 0 }}>
                                                                                Inserir manualmente
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="mt-3">
                                                                    {inserirRiscoManual ? (
                                                                        <>
                                                                            <Form.Group controlId="formCategoria" className="mb-2">
                                                                                <Form.Label style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>Categoria:</Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    name="categoria"
                                                                                    value={categoriaSelecionada ? categoriaSelecionada.id : ''}
                                                                                    size="sm"
                                                                                    style={{
                                                                                        padding: '0.2rem 0.4rem',
                                                                                        fontSize: '0.75rem',
                                                                                        border: '1px solid #0d6efd',
                                                                                    }}
                                                                                    onChange={(e: any) => {
                                                                                        const selectedCategoria = categorias.find((cat: any) => cat.id === parseInt(e.target.value));
                                                                                        setCategoriaSelecionada(selectedCategoria);
                                                                                    }}
                                                                                >   
                                                                                    <option value="">Selecione uma categoria</option>
                                                                                    {categorias.map((categoria: any) => (
                                                                                        <option key={categoria.id} value={categoria.id}>
                                                                                            {categoria.categoria}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Control>

                                                                            </Form.Group>
                                                                            <Form.Group controlId="formNome" className="mb-2">
                                                                                <Form.Label style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>Nome do Risco:</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="nome"
                                                                                    value={nomeNovoRisco}
                                                                                    onChange={(event: any) => setNomeNovoRisco(event.target.value)}
                                                                                    size="sm"
                                                                                    style={{
                                                                                        padding: '0.2rem 0.4rem',
                                                                                        fontSize: '0.75rem',
                                                                                        border: '1px solid #0d6efd'
                                                                                    }}
                                                                                />
                                                                            </Form.Group>
                                                                        </>
                                                                    ) : (
                                                                        <Form.Group controlId="formDigiteSelecione" className="mb-2">
                                                                            <Form.Label style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>Digite e Selecione:</Form.Label>
                                                                            <Autocomplete
                                                                                value={riscoSelecionado}
                                                                                onChange={(event, newValue) => {
                                                                                    if (event) {
                                                                                        event.preventDefault();
                                                                                    }
                                                                                    setRiscoSelecionado(newValue);
                                                                                }}
                                                                                onInputChange={(event, newInputValue) => {
                                                                                    if (event) {
                                                                                        event.preventDefault();
                                                                                    }
                                                                                    handleListRisk(newInputValue);
                                                                                }}
                                                                                noOptionsText="Digite e selecione"
                                                                                getOptionLabel={(option: any) => option ? option.nome : ""}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        variant="outlined"
                                                                                        label=""
                                                                                        size="small"
                                                                                        style={{
                                                                                            padding: '0.2rem 0.4rem',
                                                                                            fontSize: '0.75rem',
                                                                                            border: '1px solid #0d6efd',
                                                                                            borderRadius: '8px',
                                                                                            margin: 0,
                                                                                        }}
                                                                                        InputProps={{
                                                                                            ...params.InputProps,
                                                                                            style: {
                                                                                                padding: '0.2rem 0.4rem', // Alinha o padding
                                                                                                fontSize: '0.75rem',
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                                options={riscos}
                                                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                            />
                                                                        </Form.Group>
                                                                    )}
                                                                </Row>
                                                                <Row className="mt-auto">
                                                                    <Col md={12} className="d-flex justify-content-center">
                                                                        <Button
                                                                            variant="primary"
                                                                            size="sm"
                                                                            onClick={() => handleAddRisk()}
                                                                            style={{
                                                                                width: '20%'
                                                                            }}
                                                                        >
                                                                            Inserir
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                        <Row className="mt-3">
                                                            <Col md={12} className="d-flex justify-content-center">
                                                                <h6>Riscos ocupacionais cadastrados</h6>
                                                            </Col>
                                                        </Row>
                                                        <table style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', borderCollapse: 'separate', borderSpacing: '0' }}>
                                                            <thead>
                                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white', height: '8px' }}>
                                                                    <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', width: '30%', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Categoria</th>
                                                                    <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Nome</th>
                                                                    <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        style={{ accentColor: '#ffffff' }}
                                                                        checked={selectedRiscos.length === riscosIncluidos.length && riscosIncluidos.length > 0}
                                                                        onChange={handleSelectAllRiscos}
                                                                    />
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {riscosIncluidos.map((risco: any, index: number) => {
                                                                    return (
                                                                        <tr key={index} style={{ height: '25px' }}>
                                                                            <td style={{ fontSize: '12px', textAlign: 'center', width: '30%', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                                {risco.AteBaseRiscosCat?.categoria || risco.nome_categoria}
                                                                            </td>
                                                                            <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                                {risco.nome}
                                                                            </td>
                                                                            <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                style={{ accentColor: '#ffffff' }}
                                                                                checked={selectedRiscos.includes(risco.id)}
                                                                                onChange={() => handleSelectRiscos(risco.id)}
                                                                            />
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                        <div className="mt-3 d-flex justify-content-center">
                                                            <Button variant="danger" className='mx-2' onClick={handleDeleteRiscos} disabled={selectedRiscos.length === 0}>Excluir</Button>
                                                        </div>
                                                    </>
                                                </>
                                            ) : (
                                                <div style={{ textAlign: 'center' }}><Button>Riscos</Button></div>
                                            )}
                                        </div>
                                    </Col>
                                )}

                                {/* Coluna 3 */}
                                {visibleColumns.col3 && (
                                    <Col
                                        xs={12}
                                        md={minimizedColumns.col3 && Object.values(minimizedColumns).filter(Boolean).length < 3 ? 2 : getColumnSize()}
                                        style={{
                                            transition: 'all 0.3s ease'
                                        }}
                                        onClick={() => minimizedColumns.col3 && handleToggleMinimize('col3')}
                                    >
                                        <div
                                            style={{
                                                padding: '10px',
                                                position: 'relative',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: minimizedColumns.col3 ? 'ellipsis' : 'clip',
                                                cursor: minimizedColumns.col3 ? 'pointer' : 'default'
                                            }}
                                        >
                                            {!minimizedColumns.col3 && (
                                                <Button
                                                    variant="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleToggle('col3');
                                                    }}
                                                    style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '0.7rem' }}
                                                >
                                                    Ocultar
                                                </Button>
                                            )}
                                            {!minimizedColumns.col3 ? (
                                                <>
                                                    <h6>Exames</h6>
                                                    <hr />
                                                    <Card style={{
                                                        border: '1px solid #0d6efd',
                                                        borderRadius: '8px',
                                                        height: '350px'
                                                    }}>
                                                        <Card.Body style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                            <h6 >Inserir novo exame:</h6>
                                                            <Form.Group as={Row} controlId="formNomeExame" className="align-items-center">
                                                                <Form.Label column sm={5} style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                                                                    Nome (digite e selecione):
                                                                </Form.Label>
                                                                <Col sm={7}>
                                                                    <Autocomplete
                                                                        value={exameSelecionado || null}
                                                                        onChange={(event, newValue: any) => {
                                                                            if (event) {
                                                                                event.preventDefault();
                                                                            }
                                                                            setExameSelecionado(newValue);
                                                                            if (newValue && newValue.valor_total) {
                                                                                let valor = String(newValue.valor_total).replace(/\D/g, '');
                                                                                if (valor.length > 0) {
                                                                                    valor = (Number(valor) / 100).toFixed(2)
                                                                                        .replace('.', ',')
                                                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                                                                }
                                                                                setValor(valor); // Atualiza o valor no estado
                                                                            } else {
                                                                                setValor(''); // Limpa o valor caso não haja exame selecionado
                                                                            }
                                                                        }}
                                                                        onInputChange={(event, newInputValue) => {
                                                                            if (event) {
                                                                                event.preventDefault(); 
                                                                            }
                                                                            handleListExams(newInputValue);
                                                                        }}
                                                                        size='small'
                                                                        noOptionsText="Digite e selecione"
                                                                        getOptionLabel={(option) => option ? option.nome : ""}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                label=""
                                                                                size="small"
                                                                                style={{
                                                                                    padding: '0.2rem 0.4rem',
                                                                                    fontSize: '0.75rem',
                                                                                    border: '1px solid #0d6efd',
                                                                                    borderRadius: '8px',
                                                                                    margin: 0,
                                                                                }}
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    style: {
                                                                                        padding: '0.2rem 0.4rem',
                                                                                        fontSize: '0.75rem',
                                                                                    },
                                                                                }}
                                                                            />
                                                                        )}
                                                                        options={exames}
                                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formValorExame" className="mb-1 align-items-center">
                                                                <Form.Label column sm={5} style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                                                                    Valor do exame:
                                                                </Form.Label>
                                                                <Col sm={7}>
                                                                    <Form.Control 
                                                                        type="text"
                                                                        name="valorExame"
                                                                        value={valor || ''}
                                                                        onChange={(e: any) => {
                                                                            let valor = e.target.value.replace(/\D/g, '');
                                                                            if (valor.length > 0) {
                                                                                valor = (Number(valor) / 100).toFixed(2)
                                                                                    .replace('.', ',') 
                                                                                    .replace(/\B(?=(\d{3})+(?!\d))/g, "."); 
                                                                            }
                                                                            setValor(valor);
                                                                        }}
                                                                        size="sm"
                                                                        style={{
                                                                            padding: '0.2rem 0.4rem',
                                                                            fontSize: '0.75rem',
                                                                            border: '1px solid #0d6efd'
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            
                                                            <Row>                                                                
                                                                <Col md={5} className="d-flex flex-column align-items-start">
                                                                    <div className="w-100 d-flex flex-column">
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="option1"
                                                                                checked={admissional}
                                                                                onChange={(e) => handleCheckboxChange(e, setAdmissional)}
                                                                                className="me-2 checkbox-large"
                                                                            />
                                                                            <label htmlFor="option1" className="m-0 fs-6">Admissional</label>
                                                                        </div>
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="option2"
                                                                                checked={demissional}
                                                                                onChange={(e) => handleCheckboxChange(e, setDemissional)}
                                                                                className="me-2 checkbox-large"
                                                                            />
                                                                            <label htmlFor="option2" className="m-0 fs-6">Demissional</label>
                                                                        </div>
                                                                    </div>
                                                                </Col>

                                                                <Col md={7} className="d-flex flex-column align-items-start">
                                                                    <div className="w-100 d-flex flex-column">
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="option3"
                                                                                checked={retornoTrabalho}
                                                                                onChange={(e) => handleCheckboxChange(e, setRetornoTrabalho)}
                                                                                className="me-2 checkbox-large"
                                                                            />
                                                                            <label htmlFor="option3" className="m-0 fs-6">Retorno ao trabalho</label>
                                                                        </div>
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="option4"
                                                                                checked={mudancaRisco}
                                                                                onChange={(e) => handleCheckboxChange(e, setMudancaRisco)}
                                                                                className="me-2 checkbox-large"
                                                                            />
                                                                            <label htmlFor="option4" className="m-0 fs-6">Mudança de Risco Ocupacional</label>
                                                                        </div>
                                                                    </div>
                                                                </Col>

                                                            </Row>
                                                            <Row className="mt-1">
                                                                <Form.Group controlId='posAdmissional' className="mb-0 d-flex align-items-center" style={{ maxWidth: '400px' }}>
                                                                    <label className="m-0 fs-6 me-2">Pós Admissional</label>
                                                                    <Select 
                                                                        id="posAdmissional"
                                                                        value={posAdmissional}
                                                                        onSelect={(posAdmissional: number) => setPosAdmissional(posAdmissional)}
                                                                    >
                                                                        <Options value={0} name="Não tem" />
                                                                        <Options value={3} name="3 Meses" />
                                                                        <Options value={6} name="6 Meses" />
                                                                    </Select>
                                                                </Form.Group>
                                                            </Row>

                                                            <Row className="mt-1">
                                                                <PeriodicoSelect
                                                                    periodico={periodico}
                                                                    setPeriodico={setPeriodico}
                                                                    periodicoAPartir={periodicoAPartir}
                                                                    setPeriodicoAPartir={setPeriodicoAPartir}
                                                                    periodicoAte={periodicoAte}
                                                                    setPeriodicoAte={setPeriodicoAte}
                                                                    periodicoAntes={periodicoAntes}
                                                                    setPeriodicoAntes={setPeriodicoAntes} 
                                                                    periodicoDepois={periodicoDepois}
                                                                    setPeriodicoDepois={setPeriodicoDepois}
                                                                />
                                                            </Row>


                                                            <Row className="mt-auto">
                                                                <Col md={12} className="d-flex justify-content-center">
                                                                    <Button
                                                                        variant="primary"
                                                                        size="sm"
                                                                        onClick={() => handleAddExame()}
                                                                        style={{
                                                                            width: '20%'
                                                                        }}
                                                                    >
                                                                        Inserir
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                    <Row className="mt-3">
                                                        <Col md={12} className="d-flex justify-content-center">
                                                            <h6>Exames cadastrados</h6>
                                                        </Col>
                                                    </Row>
                                                    <table style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', borderCollapse: 'separate', borderSpacing: '0' }}>
                                                        <thead>
                                                            <tr style={{ backgroundColor: '#0d6efd', color: 'white', height: '8px' }}>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', width: '20%', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Nome</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Adm.</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Pos Adm.</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Dem.</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Ret. Tra.</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Mud. Fun.</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Periódico</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', borderRight: '1px solid #fff', whiteSpace: 'normal', wordWrap: 'break-word' }}>Valor</th>
                                                                <th style={{ fontSize: '0.75rem', padding: '6px', textAlign: 'center', fontWeight: 'normal', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                <input
                                                                type="checkbox"
                                                                style={{ accentColor: '#ffffff' }}
                                                                checked={selectedExames.length === examesIncluidos.length && examesIncluidos.length > 0}
                                                                onChange={handleSelectAllExames}
                                                                />
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {examesIncluidos.map((exame: any, index: number) => {
                                                                const isSelected = selectedExames.includes(exame.id);
                                                                return (
                                                                    <tr key={exame.id} style={{ height: '25px' }}>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', width: '20%', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {exame.nome}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingExames && isSelected ? (
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`checkbox-admissional-${exame.id}`}
                                                                                        checked={exame.admissional}
                                                                                        onChange={(e) => handleEditExame(exame.id, 'admissional', e.target.checked)}
                                                                                        className="me-2 checkbox-large"
                                                                                    />
                                                                                
                                                                            ) : (
                                                                                exame.admissional ? 'Sim' : 'Não'
                                                                            )}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingExames && isSelected ? (
                                                                                <Form.Group controlId={`formAdmissional-${exame.id}`} className="mb-0 d-flex align-items-center" style={{ maxWidth: '340px' }}>
                                                                                    
                                                                                    <select 
                                                                                        id="posAdmissional"
                                                                                        value={exame.pos_admissional}
                                                                                        onChange={(e) => handleEditExame(exame.id, 'pos_admissional', e.target.value)}
                                                                                        className="form-select form-select-sm"
                                                                                        style={{fontSize: '13px'}}
                                                                                    >
                                                                                        <option value={0}>Não tem</option>
                                                                                        <option value={3}>3 Meses</option>
                                                                                        <option value={6}>6 Meses</option>
                                                                                    </select>
                                                                                </Form.Group>
                                                                            ) : (
                                                                                exame.pos_admissional ? `${exame.pos_admissional} meses` : 'Não tem'
                                                                            )}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingExames && isSelected ? (
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`checkbox-demissional-${exame.id}`}
                                                                                        checked={exame.demissional}
                                                                                        onChange={(e) => handleEditExame(exame.id, 'demissional', e.target.checked)}
                                                                                        className="me-2 checkbox-large"
                                                                                    />
                                                                                
                                                                            ) : (
                                                                                exame.demissional ? 'Sim' : 'Não'
                                                                            )}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingExames && isSelected ? (
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`checkbox-retorno-${exame.id}`}
                                                                                        checked={exame.retorno}
                                                                                        onChange={(e) => handleEditExame(exame.id, 'retorno', e.target.checked)}
                                                                                        className="me-2 checkbox-large"
                                                                                    />
                                                                                
                                                                            ) : (
                                                                                exame.retorno ? 'Sim' : 'Não'
                                                                            )}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingExames && isSelected ? (
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`checkbox-mudanca_risco-${exame.id}`}
                                                                                        checked={exame.mudanca_risco}
                                                                                        onChange={(e) => handleEditExame(exame.id, 'mudanca_risco', e.target.checked)}
                                                                                        className="me-2 checkbox-large"
                                                                                    />
                                                                                
                                                                            ) : (
                                                                                exame.mudanca_risco ? 'Sim' : 'Não'
                                                                            )}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {isEditingExames && isSelected ? (
                                                                               <Form.Group 
                                                                               controlId={`formPeriodicidade-${exame.id}`} 
                                                                               className="d-flex align-items-center gap-2 mb-2" 
                                                                               style={{ maxWidth: '100%', flexWrap: 'nowrap' }}
                                                                               >
                                                                               {exame.per_id1 > 0 && (
                                                                                   <Form.Group 
                                                                                       controlId={`formPerAntes-${exame.id}`}
                                                                                       className="mb-0 flex-fill" 
                                                                                       style={{ minWidth: '90px' }} 
                                                                                   >
                                                                                       <label className="m-0 small me-2">Antes</label>
                                                                                       <select
                                                                                           id="periodicoAntes"
                                                                                           value={exame.periodicidade_a}
                                                                                           onChange={(e) => handleEditExame(exame.id, 'periodicidade_a', parseInt(e.target.value))}
                                                                                           className="form-select form-select-sm"
                                                                                           style={{fontSize: '14px'}}
                                                                                       >
                                                                                           <option value={0}>Não tem</option>
                                                                                           <option value={3}>3 Meses</option>
                                                                                           <option value={6}>6 Meses</option>
                                                                                           <option value={12}>12 Meses</option>
                                                                                           <option value={24}>24 Meses</option>
                                                                                           <option value={36}>36 Meses</option>
                                                                                           <option value={48}>48 Meses</option>
                                                                                           <option value={60}>60 Meses</option>
                                                                                       </select>
                                                                                   </Form.Group>
                                                                               )}
       
                                                                               {exame.periodicidade > 0 && (
                                                                                   <Form.Group 
                                                                                   controlId={`formPeriApartir-${exame.id}`}
                                                                                       className="mb-0 flex-fill" 
                                                                                       style={{ minWidth: '80px' }} 
                                                                                   >
                                                                                       <label className="m-0 small me-2">A partir</label>
                                                                                       <select
                                                                                           id="eperiodicoAPartir"
                                                                                           value={exame.per_id1}
                                                                                           onChange={(e) => handleEditExame(exame.id, 'per_id1', parseInt(e.target.value))}
                                                                                           className="form-select form-select-sm"
                                                                                           style={{fontSize: '14px'}}
                                                                                       >
                                                                                           <option value={0}>N</option>
                                                                                           {Array.from({ length: 99 - 16 + 1 }, (_, i) => (
                                                                                               <option key={i + 16} value={i + 16}>{i + 16}</option>
                                                                                           ))}
                                                                                       </select>
                                                                                   </Form.Group>
                                                                               )}
       
                                                                               <Form.Group 
                                                                                   controlId='periodico' 
                                                                                   className="mb-0 flex-fill" 
                                                                                   style={{ minWidth: '100px' }}
                                                                                   >
                                                                                   <label className="m-0 small me-2">Periódico</label>
                                                                                   <select
                                                                                       id="periodico"
                                                                                       value={exame.periodicidade}
                                                                                       onChange={(e) => handleEditExame(exame.id, 'periodicidade', parseInt(e.target.value))}
                                                                                       className="form-select form-select-sm"
                                                                                       style={{fontSize: '14px'}}
                                                                                       >
                                                                                       <option value={0}>Não tem</option>
                                                                                       <option value={3}>3 Meses</option>
                                                                                       <option value={6}>6 Meses</option>
                                                                                       <option value={12}>12 Meses</option>
                                                                                       <option value={24}>24 Meses</option>
                                                                                       <option value={36}>36 Meses</option>
                                                                                       <option value={48}>48 Meses</option>
                                                                                       <option value={60}>60 Meses</option>
                                                                                   </select>
                                                                               </Form.Group>
       
                                                                               {exame.periodicidade > 0 && (
                                                                                   <Form.Group 
                                                                                   controlId={`formPerAte-${exame.id}`} 
                                                                                   className="mb-0 flex-fill" 
                                                                                   style={{ minWidth: '80px' }}
                                                                                   >
                                                                                       <label className="m-0 small me-2">Até</label>
                                                                                       <select
                                                                                           id="perAte"
                                                                                           value={exame.per_id2}
                                                                                           onChange={(e) => handleEditExame(exame.id, 'per_id2', parseInt(e.target.value))}
                                                                                           className="form-select form-select-sm"
                                                                                           style={{fontSize: '14px'}}
                                                                                           >
                                                                                           <option value={0}>N</option>
                                                                                           {Array.from({ length: 99 - exame.per_id1 + 1 }, (_, i) => exame.per_id1 + i)
                                                                                               .filter(value => value <= 99)
                                                                                               .map(value => (
                                                                                                   <option key={value} value={value}>{value}</option>
                                                                                               ))}
                                                                                       </select>
                                                                                   </Form.Group>
                                                                               )}
                                                                               {exame.per_id2 > 0 && (
                                                                                   <Form.Group 
                                                                                       controlId={`formPerDepois-${exame.id}`}
                                                                                       className="mb-0 flex-fill" 
                                                                                       style={{ minWidth: '90px' }}
                                                                                   >
                                                                                       <label className="m-0 small me-2">Depois</label>
                                                                                       <select
                                                                                           id="eperiodicoDepois"
                                                                                           value={exame.periodicidade_d}
                                                                                           onChange={(e) => handleEditExame(exame.id, 'periodicidade_d', parseInt(e.target.value))}
                                                                                           className="form-select form-select-sm"
                                                                                           style={{fontSize: '14px'}}
                                                                                           >
                                                                                           <option value={0}>Não tem</option>
                                                                                           <option value={3}>3 Meses</option>
                                                                                           <option value={6}>6 Meses</option>
                                                                                           <option value={12}>12 Meses</option>
                                                                                           <option value={24}>24 Meses</option>
                                                                                           <option value={36}>36 Meses</option>
                                                                                           <option value={48}>48 Meses</option>
                                                                                           <option value={60}>60 Meses</option>
                                                                                       </select>
                                                                                   </Form.Group>
                                                                               )}
                                                                           </Form.Group>
                                                                            ) : (
                                                                                exame.periodicidade  ? `${exame.periodicidade} meses` : 'Não tem'
                                                                            )}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {exame.valor}
                                                                        </td>
                                                                        <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ accentColor: '#ffffff' }}
                                                                            checked={selectedExames.includes(exame.id)}
                                                                            onChange={() => handleSelectExames(exame.id)}
                                                                        />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>

                                                    <div className="mt-3 d-flex justify-content-center">
                                                        {isEditingExames ? (
                                                                <>
                                                                    <Button variant="danger" className='mx-2' onClick={handleCancelEdicoesExames} disabled={selectedExames.length === 0}>Cancelar</Button>
                                                                    <Button variant="primary" onClick={handleSaveEdicoesExames} disabled={selectedExames.length === 0}>
                                                                        Salvar
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Button variant="danger" className='mx-2' onClick={handleDeleteExames} disabled={selectedExames.length === 0}>Excluir</Button>
                                                                    <Button variant="primary" onClick={handleEditExames} disabled={selectedExames.length === 0}>
                                                                       Editar
                                                                    </Button>
                                                                </>

                                                            )}
                                                    </div>
                                                </>
                                            ) : (
                                                <div style={{ textAlign: 'center' }}><Button>Exames</Button></div>
                                            )}
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>
                <Row className="d-flex align-items-center justify-content-center mt-3 mb-3">
                    <button
                        className="btn btn-success d-flex align-items-center justify-content-center gap-2"
                        style={{ width: '100%', maxWidth: '150px', height: '40px', borderRadius: '5px' }}
                        onClick={handleSaveReaproveitamento}
                        disabled={loadingSave}
                    >
                        {loadingSave ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                            <AttachEmailIcon style={{ fontSize: '16px' }} />
                        )}
                        {loadingSave ? 'Enviando...' : 'Enviar'}
                    </button>
                </Row>
            </Main>

            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}

export default CadastrarPCMSO;
